import * as React from 'react';
import { createSvg } from './utils/createSvg';
export var DotSingle = createSvg(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M18 16a2 2 0 11-2-2 2 2 0 012 2z" })), '0 0 32 32', 'DotSingle');
//# sourceMappingURL=DotSingle.js.map